import React from "react";

const ApiLoader = () => {
  return <div className="spinner-border" style={{ color: "#fff" }}></div>;
};

export default ApiLoader;
